import { memo, useRef, useState, useCallback, useEffect, FC } from 'react'
import { IconButton, Stack, Input, InputGroup, InputRightElement } from '@chakra-ui/react'

import TagsList from './components/TagsList'
import getAssets from 'utils/assets/getAssets'

type Props = {
  values: string[]
  size?: string
  onChange: (tags: string[]) => void
  validate?: (value: string) => boolean
}

const ChipsInput: FC<Props> = ({ validate, values = [], size, onChange, ...rest }) => {
  const [tags, setTags] = useState(values)

  const CreateIcon = getAssets('Icon', 'Create')

  const inputRef = useRef<HTMLInputElement | null>(null)

  const addTag = (newTag: string) => {
    if (newTag.length > 0) {
      const updatedTags = [...tags, newTag]
      setTags(updatedTags)
    }

    setTimeout(() => {
      if (inputRef.current) inputRef.current.value = ''
    }, 100)
  }

  const removeTag = useCallback(
    (removedTag: string) => {
      setTags(tags.filter((tag) => tag !== removedTag))
    },
    [tags]
  )

  const updateTag = useCallback((tagValue: string) => {
    if (inputRef.current) inputRef.current.value = tagValue
  }, [])

  useEffect(() => {}, [tags])

  useEffect(() => {
    onChange(tags)
  }, [tags])

  return (
    <Stack>
      <InputGroup size={size}>
        <Input ref={inputRef} {...rest} />

        <InputRightElement>
          <IconButton
            aria-label="Adicionar um novo item nesta lista"
            roundedTopLeft="none"
            roundedBottomLeft="none"
            size={size}
            variant="solid"
            onClick={() => addTag(inputRef.current?.value || '')}
            icon={<CreateIcon boxSize={5} />}
          />
        </InputRightElement>
      </InputGroup>

      <TagsList updateTag={updateTag} tags={tags} size={size} removeTag={removeTag} validate={validate} />
    </Stack>
  )
}

export default memo(ChipsInput)
